import styled from 'styled-components'
import * as HeaderComponents from '../Header/styles'

export const CardStyled = styled(HeaderComponents.Header)`
    min-height: 50px;
    line-height: 50px;
    margin: 0px;
    border-top: ${({ theme }) => `1px solid ${theme['gray-400']}`};
    cursor: pointer;

    :last-child {
        border-bottom: ${({ theme }) => `1px solid ${theme['gray-400']}`};
    }

    > div {
        line-height: 50px;
        font-weight: normal;
        font-size: 12px;
        color: ${({ theme }) => theme['blue-800']};
    }
    transition: 0.2s all;
    &:hover {
        background-color: ${({ theme }) => theme['blue-200']};
    }
    padding: 9px 25px;
`

export const TrashIconWithText = styled.div`
    height: 100%;
    width: 100%;
    border-top: ${({ theme }) => `1px solid ${theme['gray-400']}`};
    padding-top: 5px;
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: 'row';
    cursor: pointer;

    span {
        font-style: normal;
        font-size: 12px;
        line-height: 16px;
        color: #d9534f;
    }
    i {
        margin-right: 1rem;
        margin-left: 2px;
        margin-bottom: 4px;
        font-size: 14px;
        line-height: 32px;
        :hover {
            color: ${({ theme }) => theme['red-700']};
        }
    }

`

export const ReportName = styled(HeaderComponents.ReportName)`
    text-transform: uppercase;
    font-family: ${({ theme }) => theme['font-semibold']};
`

export const ReportStatus = styled(HeaderComponents.ReportStatus)<{ enabled: boolean }>`
    line-height: 50px;
    .report_status_span {
        background-color: ${({ theme, enabled }) => (enabled ? theme['green-700'] : theme['gray-400'])};
        color: ${({ theme }) => theme['gray-0']};
        padding: 2px 13px;
        border-radius: 30px;
    }
`
export const Author = styled(HeaderComponents.Author)`
    line-height: 50px;
`
export const EditStatus = styled(HeaderComponents.EditStatus)``

export const LastExecution = styled(HeaderComponents.LastExecution)``

export const Actions = styled(HeaderComponents.Actions)``

export const Item = styled.span`
    margin-right: 12px;
`
